import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import GlobalModal from '@components/organisms/modal/GlobalModal';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <RecoilRoot>
    <React.StrictMode>
      <BrowserRouter>
        <GlobalModal />
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </RecoilRoot>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
